import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IconContext } from 'react-icons';
import { FaHome, FaInfoCircle, FaEnvelope, FaBars, FaTimes, FaSignInAlt, FaSignOutAlt } from 'react-icons/fa';
import Logo from './Logo';
import AnimatedBackground from './AnimatedBackground';
import '../styles/Navbar.css';

interface NavbarProps {
  isLoggedIn: boolean;
  onLogout: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ isLoggedIn, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <IconContext.Provider value={{ className: 'react-icons' }}>
      <nav className="navbar">
        <AnimatedBackground />
        <div className="navbar-container">
          <Link to="/" className="navbar-logo">
            <Logo />
          </Link>

          <div className="menu-icon" onClick={toggleMenu}>
            {isOpen ? <FaTimes /> : <FaBars />}
          </div>

          <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
            <li className="nav-item">
              <Link to="/" className="nav-link" onClick={toggleMenu}>
                <FaHome /> Home
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/about" className="nav-link" onClick={toggleMenu}>
                <FaInfoCircle /> About
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link" onClick={toggleMenu}>
                <FaEnvelope /> Contact
              </Link>
            </li>
            <li className="nav-item">
              {isLoggedIn ? (
                <Link to="/" className="nav-link" onClick={() => { toggleMenu(); onLogout(); }}>
                  <FaSignOutAlt /> Logout
                </Link>
              ) : (
                <Link to="/login" className="nav-link" onClick={toggleMenu}>
                  <FaSignInAlt /> Login
                </Link>
              )}
            </li>
          </ul>
        </div>
      </nav>
    </IconContext.Provider>
  );
};

export default Navbar;